import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppState } from '../../reducers';
import { Store } from '@ngrx/store';
import { MssoBypassLoginAction } from './msso-bypass.actions';
import { LoadStaticDataAction } from '../../shared/layout/main.actions';

@Component({
  standalone: false,
  selector: 'dsp-msso-bypass',
  templateUrl: 'msso-bypass.container.html',
  styleUrls: [ 'msso-bypass.container.scss' ]
})
export class MssoBypassContainerComponent implements OnInit {
  public form: FormGroup;

  public constructor(
    private readonly store: Store<AppState>
  ) {
  }

  public ngOnInit(): void {
    this.store.dispatch(new LoadStaticDataAction('au'));
    this.form = new FormGroup({
      username: new FormControl('', [ Validators.required, Validators.email ]),
      password: new FormControl('', [ Validators.required ])
    });
  }

  public login(): void {
    this.store.dispatch(new MssoBypassLoginAction(this.form.value));
  }
}

